import type { AxiosRequestConfig } from 'axios'
import {
  AccountVestingSearchParams,
  AccountVestingType,
  AppliedPtosApiResponse,
  ApplyMarketPlaceParams,
  ApproveAccountVestingParams,
  AxiosPagingResponse,
  BoosterEnrolledUsersResponse,
  BoosterMilestoneCreatePayload,
  BoosterMilestoneUpdatePayload,
  BoosterProgramApiItem,
  BoosterProgramCreatePayload,
  BoosterProgramDetailStatsResponse,
  BoosterProgramOverview,
  BoosterProgramStats,
  BoosterProgramUpdatePayload,
  BoosterWhitelistUploadResponse,
  CreateDaoProposalPayload,
  CreatePropertyActivityPayload,
  CreatePropertyActivityTypePayload,
  DaoClaimHistoryData,
  DaoClaimHistorySearchParams,
  DaoCreatePoolPayload,
  DaoEstimatedSaleTimePayload,
  DaoOverviewStats,
  DaoPoolApiType,
  DaoProjectProposalsType,
  DaoProjectsSearchParams,
  DaoProposalApiType,
  DaoProposalDeleteApiType,
  DaoProposalDetailType,
  DaoProposalPayload,
  DaoProposalTimelineData,
  DaoProposalUpdateApiType,
  DaoPtoProjectItemType,
  DaoReportHoldingApiType,
  DaoRewardPoolsData,
  DaoSaleResultApiType,
  DaoVotersData,
  DaoVotersSearchParams,
  DistributionListApiResponse,
  ExistingUsersApiResponse,
  HistoryType,
  MarketPlaceType,
  PagingParams,
  PartnerWhitelistUploadResponse,
  PromoCodeApiItem,
  PromoCodeCreatePayload,
  PromoCodeDistributionApiItem,
  PromoCodeListApiResponse,
  PromoCodeUpdatePayload,
  PtoContractArgs,
  PtoItemType,
  PtoOverviewType,
  PtoRentalV2ApiType,
  PtoV2ItemType,
  PtoV3CreateArgs,
  PtoV3ItemType,
  PtoV3PoolDistributionArgs,
  PtoV3PoolQuery,
  PtoV3SellingDetailsPayload,
  PtoV3UpdateContractPayload,
  PtoV3VaultStatus,
  RentalInfoPeriod,
  ResponseType,
  SearchAppliedPtosApiParams,
  SearchBoosterEnrolledUsersParams,
  SearchBoosterProgramApiParams,
  SearchDistributionsApiParams,
  SearchExistingUsersApiParams,
  SearchListReferralParams,
  SearchMarketPlaceParams,
  SearchNftCollectionParams,
  SearchPromoCodeApiParams,
  SearchPropertyActivityParams,
  SearchPTOParams,
  SearchSelectPTOParams,
  SearchVestingParams,
  StakingTokenConfigListResponse,
  StakingTokenContractType,
  StakingTokenStatisticalType,
  StakingTokenType,
  SyncAccountVestingParams,
  TokenizeCollectionType,
  UpdatePropertyActivityPayload,
  UpdatePropertyActivityTypePayload,
  UserMeyRealOverview,
  UserMeyRealSearchParams,
  UserMeyRealType,
  VestingCheckingParams,
  VestingCheckingParamsV2,
  VestingData,
  VestingNotImportedData,
  VestingStatistical,
  WhatsNewCreatePayload,
  WhatsNewDeleteResponse,
  WhatsNewItem,
  WhatsNewListResponse,
  WhatsNewMediaData,
  WhatsNewReorderPayload,
  WhatsNewStatusTogglePayload,
  WhatsNewUpdatePayload,
  WhitelistUploadRecord,
  FaqArticleDeleteResponse,
  FaqArticleDetail,
  FaqArticlePayload,
  FaqArticleReorderPayload,
  FaqArticleReorderResponse,
  FaqArticleStatusPayload,
  FaqArticleUpdateResponse,
  FaqCategoryCheckNameResponse,
  FaqCategoryDeleteResponse,
  FaqCategoryItem,
  FaqCategoryListParams,
  FaqCategoryListResponse,
  FaqCategoryPayload,
  FaqCategoryReorderPayload,
} from 'Modules'
import queryString from 'query-string'
import qs from 'query-string'

import { instance, instanceWithoutToken } from 'api-base/instance'
import { VestingTypeEnum } from 'constants/vesting'

export const AppAdmin = {
  getListProperty() {
    return instance.get<any>(`/portal-tokenize/properties`)
  },
  getListAdmin(
    pageSize: number = 10,
    pageIndex: number = 0,
    username?: string,
    activeStatus?: number
  ) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })

    if (username) {
      params.append('email', username)
    }
    if (activeStatus !== undefined) {
      params.append('activeStatus', activeStatus.toString())
    }
    return instance.get<any>(`/admin/list?${params.toString()}`)
  },
  updateUser(payload: any) {
    return instance.post<any>(`/admin/update`, payload)
  },
  createUser(payload: any) {
    return instance.post<any>(`/admin/register`, payload)
  },
  getListUser(
    pageSize: number = 10,
    pageIndex: number = 0,
    email?: string,
    phone?: string,
    kycStatus?: number,
    walletAddress?: string
  ) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })

    if (email) {
      params.append('email', email)
    }

    if (phone) {
      params.append('phone', phone)
    }
    if (kycStatus !== undefined) {
      params.append('kycStatus', kycStatus.toString())
    }
    if (walletAddress) {
      params.append('walletAddress', walletAddress)
    }
    return instance.get<any>(`/admin/user/list?${params.toString()}`)
  },
  /*********************VESTING + VESTING HMC********************/
  getVestingStatistical(type: VestingTypeEnum) {
    const path = qs.stringifyUrl({
      url: '/admin/vesting-statistical',
      query: { type: type },
    })

    return instance.get<ResponseType<VestingStatistical>>(path)
  },
  getListVesting(params: SearchVestingParams) {
    const path = qs.stringifyUrl(
      {
        url: '/admin/vesting',
        query: { ...params },
      },
      { skipEmptyString: true, skipNull: true }
    )

    return instance.get<AxiosPagingResponse<VestingData>>(path)
  },
  getVestingNotImported(type: VestingTypeEnum) {
    const path = qs.stringifyUrl({
      url: '/admin/vesting-not-imported',
      query: { type },
    })

    return instance.get<ResponseType<VestingNotImportedData[]>>(path)
  },
  vestingChecking(params: VestingCheckingParams) {
    return instance.post<any>('/admin/vesting-checking', params)
  },
  vestingCheckingV2(params: VestingCheckingParamsV2) {
    return instance.post<any>('/admin/vesting-checking', params)
  },
  getListTransaction(
    pageSize: number = 10,
    pageIndex: number = 0,
    byType?: number,
    contractAddress?: string,
    txHash?: string,
    ownerAddress?: string
  ) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })

    if (byType !== undefined) {
      params.append('byType', byType.toString())
    }
    if (contractAddress) {
      params.append('contractAddress', contractAddress)
    }
    if (txHash) {
      params.append('txHash', txHash)
    }
    if (ownerAddress) {
      params.append('ownerAddress', ownerAddress)
    }
    return instance.get<any>(`/admin/transaction/list?${params.toString()}`)
  },
  uploadWhitelistVestingToken(formData: FormData) {
    return instance.post<any>(`/airdrop/whitelist/vesting/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  uploadWhitelistVesting(formData: FormData) {
    return instance.post<any>(`/airdrop/whitelist/vesting-upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  createUserVesting(payload: VestingCheckingParams) {
    return instance.post<any>(`/admin/vesting-create`, payload)
  },
  createUserVestingV2(payload: VestingCheckingParamsV2) {
    return instance.post<any>(`/admin/vesting-create-v2`, payload)
  },
  /*********************SETTING********************/
  getConfigSetting() {
    return instance.get<any>(`/setting/list`)
  },
  getListSetting(payload?: { pageIndex: number; pageSize: number; name: string }) {
    return instance.get<any>(`/admin/setting/list`, {
      params: payload,
    })
  },
  settingUpdate(params: any) {
    return instance.post<any>(`/admin/setting/create_or_update`, params)
  },
  getListContractInfo() {
    return instance.get<ResponseType<any>>(`/admin/setting/list/contract_info`)
  },
  /*********************P2P********************/
  getListLending(pageSize: number = 10, pageIndex: number = 0, contractAddress?: string) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })

    if (contractAddress) {
      params.append('contractAddress', contractAddress)
    }

    return instance.get<any>(`/admin/p2p/list?${params.toString()}`)
  },
  getp2pDetail(code: string) {
    return instance.get<any>(`/admin/p2p/detail?code=${code}`)
  },
  getListP2PTransaction(
    poolContract: string,
    pageSize: number = 10,
    pageIndex: number = 0,
    address?: string,
    byte?: number
  ) {
    const params = new URLSearchParams({
      poolContract: poolContract.toString(),
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })
    if (address) {
      params.append('address', address)
    }
    if (byte !== undefined) {
      params.append('byte', byte.toString())
    }
    return instance.get<any>(`/admin/p2p/transaction?${params.toString()}`)
  },
  p2pUpdate(payload: any) {
    return instance.post<any>(`/admin/p2p/update`, payload)
  },
  p2pCreate(payload: any) {
    return instance.post<any>(`/admin/p2p/create`, payload)
  },
  getInfoContract(contractAddress: string) {
    return instance.post<any>(`/admin/p2p/info-contract`, {
      contractAddress,
    })
  },
  documentCreate(payload: any) {
    return instance.post<any>(`/admin/p2p/document-create-or-update`, payload)
  },
  /*********************Booster Program********************/
  getBoosterProgramStats() {
    return instance.get<ResponseType<BoosterProgramStats>>(`/admin/booster-program/stats`)
  },
  getBoosterProgramOverview() {
    return instance.get<ResponseType<BoosterProgramOverview>>(`/dashboard/booster-program-overview`)
  },
  getBoosterPrograms(params?: SearchBoosterProgramApiParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/booster-program`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<BoosterProgramApiItem>>(path)
  },
  getBoosterProgramDetail(id: string) {
    return instance.get<ResponseType<BoosterProgramApiItem>>(`/admin/booster-program/${id}`)
  },
  getBoosterProgramDetailStats(id: string) {
    return instance.get<ResponseType<BoosterProgramDetailStatsResponse>>(
      `/admin/booster-program/${id}/stats`
    )
  },
  createBoosterProgram(payload: BoosterProgramCreatePayload) {
    return instance.post<ResponseType<BoosterProgramApiItem>>(`/admin/booster-program`, payload)
  },
  updateBoosterProgram(id: string, payload: BoosterProgramUpdatePayload) {
    return instance.patch<ResponseType<BoosterProgramApiItem>>(
      `/admin/booster-program/${id}`,
      payload
    )
  },
  addBoosterMilestones(programId: string, payload: BoosterMilestoneCreatePayload[]) {
    return instance.post<ResponseType<any>>(
      `/admin/booster-program/${programId}/milestones`,
      payload
    )
  },
  updateBoosterMilestone(
    programId: string,
    milestoneId: string,
    payload: BoosterMilestoneUpdatePayload
  ) {
    return instance.patch<ResponseType<any>>(
      `/admin/booster-program/${programId}/milestones/${milestoneId}`,
      payload
    )
  },
  getBoosterProgramEnrolledUsers(programId: string, params?: SearchBoosterEnrolledUsersParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/booster-program/${programId}/enrolled-users`,
        query: params as any,
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<ResponseType<BoosterEnrolledUsersResponse>>(path)
  },
  uploadBoosterProgramWhitelist(programId: string, formData: FormData) {
    return instance.post<ResponseType<BoosterWhitelistUploadResponse>>(
      `/admin/booster-program/${programId}/whitelist/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  },
  exportBoosterProgramWhitelist(programId: string) {
    return instance.get(`/admin/booster-program/${programId}/whitelist/export`, {
      responseType: 'blob', // Set response type to blob for file download
    })
  },
  /*********************Platform Promo Code********************/
  getPromoCodes(params?: SearchPromoCodeApiParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/platform-promo-codes`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<ResponseType<PromoCodeListApiResponse>>(path)
  },
  createPromoCode(payload: PromoCodeCreatePayload) {
    return instance.post<ResponseType<PromoCodeApiItem>>(`/admin/platform-promo-codes`, payload)
  },
  updatePromoCode(id: string, payload: PromoCodeUpdatePayload) {
    return instance.patch<ResponseType<PromoCodeApiItem>>(
      `/admin/platform-promo-codes/${id}`,
      payload
    )
  },
  /** Soft delete. */
  deletePromoCode(id: string) {
    return instance.delete<ResponseType<any>>(`/admin/platform-promo-codes/${id}`)
  },
  getPromoCodeDetail(id: string) {
    return instance.get<ResponseType<PromoCodeApiItem>>(`/admin/platform-promo-codes/${id}`)
  },
  getPromoCodeAppliedPtos(id: string, params?: SearchAppliedPtosApiParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/platform-promo-codes/${id}/ptos`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<ResponseType<AppliedPtosApiResponse>>(path)
  },
  /*********************Promo Code Distribution (Whitelist & Email)********************/
  getPromoCodeDistributions(params: SearchDistributionsApiParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/platform-promo-code-distributions`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<ResponseType<DistributionListApiResponse>>(path)
  },
  /** ALL_USERS / REFERRED_USERS / EXISTING_USERS — JSON body. */
  createPromoCodeDistribution(payload: Record<string, unknown>) {
    return instance.post<ResponseType<PromoCodeDistributionApiItem>>(
      `/admin/platform-promo-code-distributions`,
      payload
    )
  },
  /** IMPORT_FILE — multipart body with the whitelist file. */
  createPromoCodeDistributionWithFile(formData: FormData) {
    return instance.post<ResponseType<PromoCodeDistributionApiItem>>(
      `/admin/platform-promo-code-distributions`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  },
  /** KYC'd users selectable into the whitelist ("Existing users" option). */
  getDistributionExistingUsers(params?: SearchExistingUsersApiParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/platform-promo-code-distributions/existing-users`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<ResponseType<ExistingUsersApiResponse>>(path)
  },
  /** Resend the distribution's email to its failed recipients. */
  resendPromoCodeDistribution(id: string) {
    return instance.post<ResponseType<{ resend: number }>>(
      `/admin/platform-promo-code-distributions/${id}/resend`
    )
  },
  /*********************PTO********************/
  getListPTO(params?: SearchPTOParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/pto`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<PtoItemType>>(path)
  },
  // All PTOs (v1 + v2) - used by PTO select dropdowns
  getListPTOAll(params?: SearchPTOParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/pto/all`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<PtoItemType>>(path)
  },
  // PTO v2 list (lazy mint flow) - returns contractName/display/sellingStatus/mint/total
  getListPTOV2(params?: SearchPTOParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/pto/v2`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<PtoV2ItemType>>(path)
  },
  getPTOV2Detail(id: string) {
    return instance.get<any>(`/admin/pto/v2/${id}`)
  },
  // PTO v2 create (basic info only - price/fee/phases are set via selling-details)
  ptoV2Create(payload: any) {
    return instance.post<any>(`/admin/pto/v2`, payload)
  },
  // PTO v2 update basic info
  ptoV2Update(id: string, payload: any) {
    return instance.patch<any>(`/admin/pto/v2/${id}`, payload)
  },
  // PTO v2 list for sale - persists pricePerNFT/buyingFeeBP/phases
  ptoV2UpdateSellingDetails(id: string, payload: any) {
    return instance.patch<any>(`/admin/pto/${id}/selling-details`, payload)
  },
  /*********************PTO V3 (ERC-3643)********************/
  // Flow per note-fe-pto-v3-full-flow.md - the BE returns params, the admin wallet signs
  getListPTOV3(params?: SearchPTOParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/pto/v3`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<PtoV3ItemType>>(path)
  },
  getPTOV3Detail(id: string) {
    // any: the detail carries v2-shaped extras (goldenTickets, revenueSharingRental...)
    return instance.get<any>(`/admin/pto/v3/${id}`)
  },
  // Step 1 - same body as v2 + symbol (required, max 10), no royaltyFee
  ptoV3Create(payload: any) {
    return instance.post<ResponseType<PtoV3ItemType>>(`/admin/pto/v3`, payload)
  },
  // Same as v2 update, no symbol (set once at createPTO), no royaltyFee
  ptoV3Update(id: string, payload: any) {
    return instance.patch<ResponseType<PtoV3ItemType>>(`/admin/pto/v3/${id}`, payload)
  },
  // Step 3 - PTOParams for PTOOrchestrator.createPTO
  ptoV3GetCreateArgs(id: string) {
    return instance.get<ResponseType<PtoV3CreateArgs>>(`/admin/pto/${id}/create-contract`)
  },
  // Step 4 (contractAddress + onchainId) and step 6 (vaultAddress + vaultIdentity)
  ptoV3UpdateContract(id: string, payload: PtoV3UpdateContractPayload) {
    return instance.patch<any>(`/admin/pto/${id}/contract`, payload)
  },
  // Step 2 - v3 selling details: pricePerPTO (USDC), buyingFeeBP (%), phases with the v3 names
  ptoV3UpdateSellingDetails(id: string, payload: PtoV3SellingDetailsPayload) {
    return instance.patch<any>(`/admin/pto/v3/${id}/selling-details`, payload)
  },
  // Step 5 - params for PTOOrchestrator.createDistributionPool (claim pre-signed by the BE).
  // Query is in raw units (USDC / %), the response is in contract units. Call it right
  // before sending the tx: salt + signature are only valid for that attempt.
  ptoV3GetPoolDistributionArgs(id: string, params?: PtoV3PoolQuery) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/pto/${id}/create-pool-distribution`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )
    return instance.get<ResponseType<PtoV3PoolDistributionArgs>>(path)
  },
  // Step 9 - check the vault on-chain now (verified + balance) instead of waiting for the hook
  ptoV3SyncVaultStatus(id: string) {
    return instance.post<ResponseType<PtoV3VaultStatus>>(`/admin/pto/${id}/vault-status/sync`)
  },
  getSelectPTO(params: SearchSelectPTOParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/staking-tokenize-collection/select-tokenize`,
        query: {
          ...params,
        },
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<any>(path)
  },
  getListPTOTransaction(params: {
    contractAddress: string
    ownerAddress?: string
    type?: number | null
    limit: number
    page: number
  }) {
    return instance.post<any>(`/admin/pto/transaction`, params)
  },
  // Export PTO purchase transactions as CSV (same filters as the list; old PTO + ERC-3643).
  exportPTOTransaction(params: {
    contractAddress: string
    ownerAddress?: string
    type?: number | null
  }) {
    const path = queryString.stringifyUrl(
      { url: '/admin/pto/transaction/export', query: params },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get(path, { responseType: 'blob' })
  },
  getPTODetail(code: string) {
    return instance.get<any>(`/admin/pto/${code}`)
  },
  // Market chart shown on the PTO Details > Market tab (Confluence 5.4).
  getPtoMarketChart(id: string) {
    return instance.get<any>(`/admin/pto/${id}/market-chart`)
  },
  updatePtoMarketChart(id: string, payload: { columns: { label: string; value: number }[] }) {
    return instance.post<any>(`/admin/pto/${id}/market-chart`, payload)
  },
  getPTOOverview() {
    return instance.get<ResponseType<PtoOverviewType>>(`/admin/pto/overview-analyze`)
  },
  ptoUpdate(code: string, payload: any) {
    return instance.patch<any>(`/admin/pto/${code}`, payload)
  },
  // Enable (1) / disable (0) sending the PTO as a gift
  updateSendGiftStatus(id: string, sendGiftStatus: 0 | 1) {
    return instance.patch<any>(`/admin/tokenize-gift/${id}`, { sendGiftStatus })
  },
  ptoUpdateContract(code: string, payload: any) {
    return instance.patch<any>(`/admin/pto/${code}/contract`, payload)
  },
  ptoCreate(payload: any) {
    return instance.post<any>(`/admin/pto`, payload)
  },
  ptoGetArgs(id: string) {
    return instance.get<ResponseType<PtoContractArgs>>(`/admin/pto/${id}/create-contract`)
  },
  ptoMint(id: string) {
    return instance.post<any>(`/admin/pto/${id}/mint`)
  },
  getDocumentDetails(code: string) {
    return instance.get<any>(`/admin/p2p/document-detail`, {
      params: { code },
    })
  },
  getDocumentDetailsPTO(code: string) {
    return instance.get<any>(`/admin/pto/${code}/document-detail`)
  },
  getInfoContractPTO(contractAddress: string) {
    return instance.get<any>('/admin/pto/info-contract', {
      params: {
        contractAddress,
      },
    })
  },
  documentCreatePTO(payload: any) {
    return instance.post<any>(`/admin/pto/document-create-or-update`, payload)
  },
  uploadIPFS(formData: FormData) {
    return instance.post<any>(`/admin/media/ipfs`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTokenizeSpecials(tokenizeId: string) {
    return instance.get<any>(`/admin/tokenize-special/tokenize/${tokenizeId}`)
  },
  uploadWhitelistPTO(id: string, formData: FormData) {
    return instance.patch<any>(`/admin/pto/${id}/upload-whitelist`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getPTOWhitelistHistory(id: string, params?: PagingParams) {
    const path = queryString.stringifyUrl(
      {
        url: `/admin/pto/${id}/whitelist-history`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )
    return instance.get<AxiosPagingResponse<WhitelistUploadRecord>>(path)
  },
  exportPTOWhitelistUpload(id: string, uploadId: string) {
    return instance.get(`/admin/pto/${id}/whitelist-history/${uploadId}/export`, {
      responseType: 'blob',
    })
  },
  createRentalInfo(id: string, payload: RentalInfoPeriod) {
    return instance.post<any>(`/admin/pto/${id}/revenue-sharing-rental`, payload)
  },
  // V2 (RevenueSharingRentalFactoryV2): same body as V1, BE also prepares the
  // createRevenueRentalPool calldata for the admin wallet to sign. Retry-safe:
  // re-calling while the latest period is unconfirmed reuses it.
  createRentalInfoV2(id: string, payload: RentalInfoPeriod) {
    return instance.post<ResponseType<PtoRentalV2ApiType>>(
      `/admin/pto/${id}/revenue-sharing-rental/v2`,
      payload
    )
  },
  updateRentalInfo(ptoId: string, rentalId: string, payload: Partial<RentalInfoPeriod>) {
    return instance.patch<any>(`/admin/pto/${ptoId}/revenue-sharing-rental/${rentalId}`, payload)
  },
  deleteRentalInfo(ptoId: string, rentalId: string) {
    return instance.delete<any>(`/admin/pto/${ptoId}/revenue-sharing-rental/${rentalId}`)
  },
  /*********************PTO Rewards********************/
  createRewardPool(payload: {
    tokenizeId: string
    ownerAddress: string
    asset: 'MEY' | 'USDC'
    rewards: {
      rarity?: number
      rewardAmount: number
      activationDate?: string
    }[]
  }) {
    return instance.post<any>('/admin/reward-pool', payload)
  },
  updateRewardContractAddress({
    rewardPoolId,
    contractAddress,
  }: {
    rewardPoolId: string
    contractAddress: string
  }) {
    return instance.patch(`/admin/reward-pool/${rewardPoolId}/contract`, {
      contractAddress,
    })
  },
  deleteRewardPool({ rewardPool, rarityId }: { rewardPool: string; rarityId: number }) {
    return instance.delete<any>(`/admin/reward-pool/${rewardPool}/${rarityId}`)
  },
  getListRewardsPool(params?: { page?: number; limit?: number }) {
    return instance.get<any>('/admin/reward-pool', { params })
  },
  getListWinnerRewardsPool(params?: { page?: number; limit?: number }) {
    return instance.get<any>('/admin/pto/winners', { params })
  },
  /*********************DAO********************/
  // DAO Voting v2 - overview stat cards
  getDaoVotingOverview() {
    return instance.get<ResponseType<DaoOverviewStats>>(`/admin/dao-voting/overview`)
  },
  // DAO Voting v2 - PTO project list
  getDaoVotingProjects(params?: DaoProjectsSearchParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/dao-voting/pto-projects`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<AxiosPagingResponse<DaoPtoProjectItemType>>(path)
  },
  // DAO Voting v2 - project header + proposal history of one PTO project
  getDaoVotingProjectProposals(tokenizeId: string) {
    return instance.get<ResponseType<DaoProjectProposalsType>>(
      `/admin/dao-voting/pto-projects/${tokenizeId}/proposals`
    )
  },
  // DAO Voting v2 - proposal detail (full content + live vote stats)
  getDaoVotingProposalDetail(id: string) {
    return instance.get<ResponseType<DaoProposalDetailType>>(`/admin/dao-voting/proposals/${id}`)
  },
  // DAO Voting v2 - proposal milestone timeline
  getDaoVotingProposalTimeline(id: string) {
    return instance.get<ResponseType<DaoProposalTimelineData>>(
      `/admin/dao-voting/proposals/${id}/timeline`
    )
  },
  // DAO Voting v2 - estimated asset sale duration of one proposal
  updateDaoVotingEstimatedSaleTime(id: string, payload: DaoEstimatedSaleTimePayload) {
    return instance.patch<ResponseType<any>>(
      `/admin/dao-voting/proposals/${id}/estimated-sale-time`,
      payload
    )
  },
  // DAO Voting v2 - record off-chain sale outcome of one proposal (SRS 5.8)
  reportDaoVotingSaleResult(id: string, payload: { success: boolean }) {
    return instance.post<ResponseType<DaoSaleResultApiType>>(
      `/admin/dao-voting/proposals/${id}/sale-result`,
      payload
    )
  },
  // DAO Voting v2 - report the asset back to Holding after a failed sale (Update Status)
  reportDaoVotingHolding(id: string) {
    return instance.post<ResponseType<DaoReportHoldingApiType>>(
      `/admin/dao-voting/proposals/${id}/report-holding`
    )
  },
  // DAO Voting v2 - voters of one proposal (server-side search + paging)
  getDaoVotingProposalVoters(id: string, params?: DaoVotersSearchParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/dao-voting/proposals/${id}/voters`,
        query: params as any,
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )

    return instance.get<ResponseType<DaoVotersData>>(path)
  },
  // DAO Voting v2 - create proposal (action: DRAFT | PUBLISH)
  createDaoVotingProposal(payload: CreateDaoProposalPayload) {
    return instance.post<ResponseType<DaoProposalApiType>>('/admin/dao-voting/proposals', payload)
  },
  // DAO Voting v2 - update Draft/Scheduled proposal
  updateDaoVotingProposal(id: string, payload: DaoProposalPayload) {
    return instance.patch<ResponseType<DaoProposalUpdateApiType>>(
      `/admin/dao-voting/proposals/${id}`,
      payload
    )
  },
  // DAO Voting v2 - delete Draft/Scheduled proposal (ERC-3643 Scheduled/Deleting returns deleteCall)
  deleteDaoVotingProposal(id: string) {
    return instance.delete<ResponseType<DaoProposalDeleteApiType>>(
      `/admin/dao-voting/proposals/${id}`
    )
  },
  // DAO Voting v2 - staking + rental pool info for the System Actions card (SRS 5.8/5.9)
  // DAO Voting v2 - claim reward/refund history of a PTO project (SRS 5.10)
  getDaoVotingClaimHistory(tokenizeId: string, params?: DaoClaimHistorySearchParams) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/dao-voting/pto-projects/${tokenizeId}/claim-history`,
        query: params as any,
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<ResponseType<DaoClaimHistoryData>>(path)
  },
  getDaoVotingRewardPools(tokenizeId: string) {
    return instance.get<ResponseType<DaoRewardPoolsData>>(
      `/admin/dao-voting/pto-projects/${tokenizeId}/reward-pools`
    )
  },
  // DAO Voting v2 - create Refund / RWA Rewards pool (SRS 5.9)
  createDaoVotingPool(payload: DaoCreatePoolPayload) {
    return instance.post<ResponseType<DaoPoolApiType>>('/admin/dao-voting/pools', payload)
  },
  /*********************STAKING********************/
  getListStaking(payload?: {
    pageIndex: number // pageIndex start from 0
    pageSize: number
    poolContract?: string
    status?: number
    stakingTimeSecond?: number
  }) {
    return instance.get<any>(`/admin/staking/list`, {
      params: payload,
    })
  },
  getListStakingDetails(poolContract: string) {
    return instance.get<any>(`/admin/staking/list`, {
      params: { poolContract },
    })
  },
  getUsersListStaking(payload?: {
    pageIndex: number
    pageSize: number
    poolContract: string
    address?: string
    byType?: any
  }) {
    return instance.get<any>(`/admin/staking/get-history`, {
      params: payload,
    })
  },
  stakingUpdate(params: any) {
    return instance.post<any>(`/admin/staking/update`, params)
  },
  stakingGetLogo(params: any) {
    return instance.post<any>(`/portal-tokenize/upload`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getStakingViewInfo(code: any) {
    return instance.post<any>(`/admin/staking/info-contract`, code)
  },
  stakingCreate(params: any) {
    return instance.post<any>(`/admin/staking/create`, params)
  },
  /*********************STAKING TOKEN********************/
  getStatisticalStakingToken() {
    return instance.get<ResponseType<StakingTokenStatisticalType>>(
      '/admin/staking-token/statistical'
    )
  },
  getStatisticalPool(id: string) {
    return instance.get<ResponseType<StakingTokenStatisticalType>>(
      `/admin/staking-token/${id}/statistical`
    )
  },
  getListStakingToken(payload?: {
    page: number // pageIndex start from 0
    limit: number
    contractAddress?: string
  }) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-token',
        query: payload,
      },
      { skipNull: true, skipEmptyString: true }
    )

    return instance.get<AxiosPagingResponse<StakingTokenType>>(path)
  },
  getStakingTokenContractInfo(contractAddress: any, poolClassify?: number) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-token/info-contract',
        query: { contractAddress, poolClassify },
      },
      { skipNull: true, skipEmptyString: true }
    )

    return instance.get<ResponseType<StakingTokenContractType>>(path)
  },
  getDetailStakingToken(id: string) {
    return instance.get<ResponseType<StakingTokenType>>(`/admin/staking-token/${id}`)
  },
  createStakingToken(params: any) {
    return instance.post<any>(`/admin/staking-token`, params)
  },
  updateStakingToken(id: string, params: any) {
    return instance.patch<any>(`/admin/staking-token/${id}`, params)
  },
  getListTransactionStaking(payload?: {
    page: number
    limit: number
    contractAddress: string
    ownerAddress?: string
  }) {
    return instance.post<AxiosPagingResponse<HistoryType>>(
      `/admin/staking-token/transaction`,
      payload
    )
  },
  // Export staking token transactions as CSV (same filters as the list).
  exportTransactionStaking(params: {
    contractAddress: string
    ownerAddress?: string
    type?: number | null
  }) {
    const path = queryString.stringifyUrl(
      { url: '/admin/staking-token/transaction/export', query: params },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get(path, { responseType: 'blob' })
  },
  /*********************STAKING TOKEN CONFIG********************/
  getListStakingTokenConfig(payload?: { page: number; limit: number; name?: string }) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-token-config',
        query: payload,
      },
      { skipNull: true, skipEmptyString: true }
    )

    return instance.get<ResponseType<StakingTokenConfigListResponse>>(path)
  },
  createStakingTokenConfig(params: {
    stakingTokenId: string
    name: string
    value: string
    isActive: boolean
  }) {
    return instance.post<any>(`/admin/staking-token-config`, params)
  },
  updateStakingTokenConfig(id: string, params: { value: string; isActive: boolean }) {
    return instance.put<any>(`/admin/staking-token-config/${id}`, params)
  },
  deleteStakingTokenConfig(id: string) {
    return instance.delete<any>(`/admin/staking-token-config/${id}`)
  },
  /*********************STAKING TOKENIZE NFT********************/
  getDetailStakingTokenize(id: string) {
    return instance.get<any>(`/admin/staking-tokenize/${id}`)
  },
  getListStakingTokenize() {
    return instance.get<any>(`/admin/staking-tokenize`)
  },
  getStakingTokenizeViewInfo(contractAddress: any) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-tokenize/info-contract',
        query: {
          contractAddress: contractAddress,
        },
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  stakingTokenizeCreate(params: any) {
    return instance.post<any>(`/admin/staking-tokenize`, params)
  },
  stakingTokenizeUpdate(id: string, params: any) {
    return instance.patch<any>(`/admin/staking-tokenize/${id}`, params)
  },
  stakingTokenizeTransaction(params: any) {
    return instance.post<any>(`/admin/staking-tokenize/transaction`, params)
  },
  // Export staking NFT (PTO) transactions as CSV (same filters as the list).
  exportStakingTokenizeTransaction(params: {
    contractAddress: string
    ownerAddress?: string
    type?: number | null
    tokenize?: string
  }) {
    const path = queryString.stringifyUrl(
      { url: '/admin/staking-tokenize/transaction/export', query: params },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get(path, { responseType: 'blob' })
  },
  stakingTokenizeOverviewAnalyze(id?: string) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-tokenize/overview-analyze',
        query: {
          id: id,
        },
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  getListNftCollection(
    params: SearchNftCollectionParams &
      PagingParams &
      Required<Pick<SearchNftCollectionParams, 'stakingTokenize'>>
  ) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-tokenize-collection',
        query: {
          ...params,
        },
      },
      { skipNull: true, skipEmptyString: true }
    )

    return instance.get<AxiosPagingResponse<TokenizeCollectionType>>(path)
  },
  getDetailNftCollection(params: Required<SearchNftCollectionParams>) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-tokenize-collection/detail',
        query: {
          ...params,
        },
      },
      { skipNull: true, skipEmptyString: true }
    )

    return instance
      .get<ResponseType<TokenizeCollectionType>>(path)
      .then((res) => res.data.data)
      .catch(() => {
        return null
      })
  },
  addNftCollection(params: any) {
    return instance.post<any>(`/admin/staking-tokenize-collection`, params)
  },
  /*********************AUTH********************/
  login({
    userName,
    password,
    otp,
    newPassword,
  }: {
    userName: string
    password: string
    otp?: any
    newPassword?: string
  }) {
    return instanceWithoutToken.post<any>(`/admin/login`, {
      userName,
      password,
      otp,
      newPassword,
    })
  },
  changePassword({ oldPassword, newPassword }: { oldPassword: string; newPassword?: string }) {
    return instance.post<any>(`/admin/change-pass`, {
      oldPassword,
      newPassword,
    })
  },
  storeGoogleId(payload: any) {
    return instance.post<any>(`/admin/storeGoogleId`, payload)
  },
  /*********************UPLOAD********************/
  uploadSingleFile(formData: FormData) {
    return instance.post<any>(`/portal-tokenize/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  uploadMultipleFiles(formData: FormData) {
    return instance.post<any>(`/portal-tokenize/uploads`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getListReferral(params: SearchListReferralParams) {
    return instance.post<any>(`/admin/referral/search`, params)
  },
  getTreeReferral(payload?: { walletAddress: any }) {
    return instance.get<any>(`/admin/referral/tree`, {
      params: payload,
    })
  },
  getReferralReport() {
    return instance.get<any>(`/admin/referral/statistical`)
  },
  getReferralUser(params: any) {
    return instance.post<any>(`/admin/referral/referral-network`, params)
  },
  getReferralPerformance(payload: {
    walletAddress: string
    ptoId?: string
    fromAddress?: string
    page?: number
    limit?: number
  }) {
    return instance.post<any>(`/admin/referral-system/performance`, payload)
  },
  getReferralClaimHistory(params: {
    page?: number
    limit?: number
    sort?: string
    search?: string
    status?: string | number | null
  }) {
    return instance.get<any>(`/admin/referral/claim-history`, { params })
  },

  getDashboard() {
    return instance.get<any>(`/dashboard/list`)
  },
  getListEmail(size: any, page: any, walletAddress?: string, email?: string, hashEmail?: string) {
    const params = new URLSearchParams({
      size: size.toString(),
      page: page.toString(),
    })
    if (walletAddress) {
      params.append('walletAddress', walletAddress)
    }
    if (email) {
      params.append('email', email)
    }
    if (hashEmail) {
      params.append('hashEmail', hashEmail)
    }
    return instance.get<any>(`/account-wl/list?${params.toString()}`)
  },
  getListEmailV2(params: {
    size: number
    page: number
    walletAddress?: string
    email?: string
    hashEmail?: string
    dateFrom?: number
    dateTo?: number
    isSign?: number
    isVerify?: number
  }) {
    return instance.get<any>(`/account-wl/list-ver2`, { params })
  },
  exportVestingHmcV2() {
    return instance.get(`/account-wl/export/vesting_hmc_v2`, { responseType: 'blob' })
  },
  exportVestingVentureV2() {
    return instance.get(`/account-wl/export/vesting_venture_v2`, { responseType: 'blob' })
  },
  export() {
    return instance.get<any>(`/account-wl/export`)
  },
  exportByType(type: string, params?: Record<string, any>) {
    return instance.get(`/account-wl/export/${type}`, {
      params,
      responseType: 'blob', // Set response type to blob for file download
    })
  },
  /*********************AIRDROP********************/
  getListAirDrop(pageSize: number = 10, pageIndex: number = 0) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })
    return instance.get<any>(`/airdrop/getAll?${params.toString()}`)
  },
  createAirDrop(payload: any) {
    return instance.post<any>(`/airdrop/create`, payload)
  },
  airDropDetails(code: string) {
    return instance.get<any>(`/airdrop/getDetail`, {
      params: { code },
    })
  },
  updateAirDrop(payload: any) {
    return instance.post<any>(`/airdrop/update`, payload)
  },
  getListWhiteList(code: string, pageSize: number = 10, pageIndex: number = 0, address?: string) {
    const params = new URLSearchParams({
      code: code.toString(),
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
    })
    if (address) {
      params.append('address', address)
    }
    return instance.get<any>(`/airdrop/whitelist/list?${params.toString()}`)
  },
  uploadWhitelist(formData: FormData, code: string) {
    formData.append('code', code)
    return instance.post<any>(`/airdrop/whitelist/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  /*********************MARKETPLACE********************/
  getListMarketplace(params?: SearchMarketPlaceParams) {
    return instance.post<AxiosPagingResponse<MarketPlaceType>>(`/admin/marketplace/search`, params)
  },
  getDetailMarketplace(id?: string) {
    const path = `/admin/marketplace/${id}`
    return instance.get<ResponseType<MarketPlaceType>>(path)
  },
  applyTokenizeToMarketPlace(params: ApplyMarketPlaceParams) {
    return instance.post<any>(`/admin/marketplace/apply`, params)
  },
  updateMarketplace(payload: any) {
    return instance.post<any>(`/admin/market/update`, payload)
  },
  getActivity(pageSize: number = 10, pageIndex: number = 0, code: string) {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageIndex: pageIndex.toString(),
      code,
    })
    return instance.get<any>(`/admin/market/activity?${params.toString()}`)
  },
  getReportMarketPlace(code: string) {
    return instance.get<any>(`/admin/market/report?code=${code}`)
  },
  updateMarketListen(payload: any) {
    return instance.post<any>(`/setting/update-value`, payload)
  },
  /*********************PORTAL TOKEN********************/
  getListPortal(page: number = 1, size: number = 10) {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    })
    return instance.get<any>(`/admin/portal-tokenize/list?${params.toString()}`)
  },
  approveRequest(payload: any) {
    return instance.post<any>(`/admin/portal-tokenize/approve-type`, payload)
  },
  getPortalDetails(code: string) {
    return instance.get<any>(`/admin/portal-tokenize/detail?code=${code}`)
  },
  /*********************BANNER********************/
  getListBanner(pageSize: number = 10, pageIndex: number = 1) {
    const params = new URLSearchParams({
      limit: pageSize.toString(),
      page: pageIndex.toString(),
    })
    return instance.get<any>(`/admin/banner?${params.toString()}`)
  },
  getDetailBanner(id: string) {
    return instance.get<any>(`/admin/banner/${id}`)
  },
  createBanner(payload: {
    name: string
    image: string
    link?: string
    type: number
    isActive: boolean
  }) {
    return instance.post<any>(`/admin/banner`, payload)
  },
  updateBanner(
    id: string,
    payload: {
      name?: string
      image?: string
      link?: string
      type?: number
      isActive?: boolean
    }
  ) {
    return instance.patch<any>(`/admin/banner/${id}`, payload)
  },
  deleteBanner(id: string) {
    return instance.delete<any>(`/admin/banner/${id}`)
  },
  /*********************ACCOUNT VESTING********************/
  getListAccountVesting(input: AccountVestingSearchParams) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/account-vesting',
        query: {
          ...input,
        },
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )
    return instance.get<AxiosPagingResponse<AccountVestingType>>(path)
  },
  syncAccountVesting(input: SyncAccountVestingParams) {
    return instance.post<any>('admin/account-vesting/sync', input)
  },
  approveAccountVesting(input: ApproveAccountVestingParams) {
    return instance.post<any>('admin/account-vesting/approve', input)
  },
  /*********************PTO REFERRAL********************/
  getPtoReferralStats() {
    return instance.get<any>('/admin/referral-system/stats')
  },
  getPtoReferralConfigs(params?: PagingParams) {
    return instance.post<any>('/admin/referral-system/pto-configs', params)
  },
  updatePtoReferralConfig(ptoId: string, payload: { referralReward: number; rewardToken: number }) {
    return instance.put<any>(`/admin/referral-system/pto-configs/${ptoId}`, payload)
  },

  /*********************PARTNER REFERRAL********************/
  // Partner referral stats (doc #11).
  getPartnerReferralStats() {
    return instance.get<any>('/admin/partner-referral-wl/stats')
  },
  // Partner PTO reward-config list (doc #13).
  getPartnerReferralConfigs(params?: { page?: number; limit?: number; sort?: string }) {
    const path = qs.stringifyUrl(
      { url: '/admin/partner-referral-wl/pto-configs', query: params as any },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  // Update partner reward by PTO (doc #10).
  updatePartnerRewardConfig(ptoId: string, payload: { reward: number; rewardToken: number }) {
    return instance.put<any>(`/admin/partner-referral-wl/reward-config/${ptoId}`, payload)
  },
  // Partner whitelist users list (doc #12).
  getPartnerReferralWhitelist(params?: {
    page?: number
    limit?: number
    sort?: string
    keyword?: string
    status?: number
  }) {
    const path = qs.stringifyUrl(
      { url: '/admin/partner-referral-wl', query: params as any },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  // Upload partner referral whitelist (doc #7).
  uploadPartnerReferralWhitelist(formData: FormData) {
    return instance.post<ResponseType<PartnerWhitelistUploadResponse>>(
      '/admin/partner-referral-wl/upload',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
  },
  // Export whitelist by upload id (doc #8).
  exportPartnerReferralWhitelist(uploadId: string) {
    return instance.get(`/admin/partner-referral-wl/uploads/${uploadId}/export`, {
      responseType: 'blob',
    })
  },
  // Update whitelist record status: active 1, deactivated 2, delete 3 (doc #9).
  updatePartnerReferralStatus(id: string, status: number) {
    return instance.patch<any>(`/admin/partner-referral-wl/${id}/status`, { status })
  },
  // Transactions (PTO purchases) of users invited by a referral partner.
  // Default sort from BE: earned desc, then createdAt desc.
  getPartnerReferralTransactions(
    walletAddress: string,
    params?: { ptoId?: string; fromAddress?: string; page?: number; limit?: number }
  ) {
    const path = qs.stringifyUrl(
      { url: `/admin/partner-referral-wl/${walletAddress}/transactions`, query: params as any },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  // Export the partner's referral transactions (same filters as the list).
  exportPartnerReferralTransactions(
    walletAddress: string,
    params?: { ptoId?: string; fromAddress?: string }
  ) {
    const path = qs.stringifyUrl(
      {
        url: `/admin/partner-referral-wl/${walletAddress}/transactions/export`,
        query: params as any,
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get(path, { responseType: 'blob' })
  },

  /*********************USER MEY REAL********************/
  getUserMeyRealList(params: UserMeyRealSearchParams) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/mey-real-account',
        query: {
          ...params,
        },
      },
      {
        skipNull: true,
        skipEmptyString: true,
      }
    )
    return instance.get<AxiosPagingResponse<UserMeyRealType>>(path)
  },
  getUserMeyRealOverview(): Promise<{
    data: ResponseType<UserMeyRealOverview>
  }> {
    return instance.get('/admin/mey-real-account/statistics')
  },
  blockUserMeyReal(userId: string) {
    return instance.post<ResponseType<boolean>>(`/admin/mey-real-account/${userId}/block`)
  },
  unblockUserMeyReal(userId: string) {
    return instance.post<ResponseType<boolean>>(`/admin/mey-real-account/${userId}/unblock`)
  },
  /*********************PROPERTY ACTIVITIES********************/
  getPropertyActivities(params?: SearchPropertyActivityParams) {
    const path = qs.stringifyUrl(
      { url: '/admin/property-activities', query: params as any },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<any>(path)
  },
  getPropertyActivityDetail(activityId: string) {
    return instance.get<any>(`/admin/property-activities/${activityId}`)
  },
  createPropertyActivity(payload: CreatePropertyActivityPayload) {
    return instance.post<any>('/admin/property-activities', payload)
  },
  updatePropertyActivity(activityId: string, payload: UpdatePropertyActivityPayload) {
    return instance.put<any>(`/admin/property-activities/${activityId}`, payload)
  },
  deletePropertyActivity(activityId: string) {
    return instance.delete<any>(`/admin/property-activities/${activityId}`)
  },
  getPropertyActivityTypes() {
    return instance.get<any>('/admin/property-activities/types')
  },
  createPropertyActivityType(payload: CreatePropertyActivityTypePayload) {
    return instance.post<any>('/admin/property-activities/types', payload)
  },
  updatePropertyActivityType(typeId: string, payload: UpdatePropertyActivityTypePayload) {
    return instance.put<any>(`/admin/property-activities/types/${typeId}`, payload)
  },
  deletePropertyActivityType(typeId: string) {
    return instance.delete<any>(`/admin/property-activities/types/${typeId}`)
  },
  uploadPropertyActivityImages(formData: FormData) {
    return instance.post<any>('/admin/property-activities/upload-images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  uploadPropertyActivityDocuments(formData: FormData) {
    return instance.post<any>('/admin/property-activities/upload-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  /*********************WHATS NEW********************/
  getWhatsNewList() {
    return instance.get<ResponseType<WhatsNewListResponse>>('/admin/whats-new')
  },
  getWhatsNewDetail(id: string) {
    return instance.get<ResponseType<WhatsNewItem>>(`/admin/whats-new/${id}`)
  },
  createWhatsNew(payload: WhatsNewCreatePayload) {
    return instance.post<ResponseType<WhatsNewItem>>('/admin/whats-new', payload)
  },
  updateWhatsNew(id: string, payload: WhatsNewUpdatePayload) {
    return instance.patch<ResponseType<WhatsNewItem>>(`/admin/whats-new/${id}`, payload)
  },
  updateWhatsNewStatus(id: string, payload: WhatsNewStatusTogglePayload) {
    return instance.patch<ResponseType<WhatsNewItem>>(`/admin/whats-new/${id}/status`, payload)
  },
  reorderWhatsNew(payload: WhatsNewReorderPayload) {
    return instance.put<ResponseType<WhatsNewListResponse>>('/admin/whats-new/order', payload)
  },
  uploadWhatsNewMedia(formData: FormData, config?: AxiosRequestConfig) {
    return instance.post<ResponseType<WhatsNewMediaData>>('/admin/whats-new/media', formData, {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteWhatsNew(id: string) {
    return instance.delete<ResponseType<WhatsNewDeleteResponse>>(`/admin/whats-new/${id}`)
  },
  /*********************FAQ CATEGORIES********************/
  getFaqCategoryList(params?: FaqCategoryListParams) {
    return instance.get<ResponseType<FaqCategoryListResponse>>('/admin/faq/categories', { params })
  },
  checkFaqCategoryName(name: string, excludeId?: string) {
    return instance.get<ResponseType<FaqCategoryCheckNameResponse>>('/admin/faq/categories/check-name', {
      params: { name, excludeId },
    })
  },
  createFaqCategory(payload: FaqCategoryPayload) {
    return instance.post<ResponseType<FaqCategoryItem>>('/admin/faq/categories', payload)
  },
  updateFaqCategory(id: string, payload: FaqCategoryPayload) {
    return instance.patch<ResponseType<FaqCategoryItem>>(`/admin/faq/categories/${id}`, payload)
  },
  reorderFaqCategory(id: string, payload: FaqCategoryReorderPayload) {
    return instance.patch<ResponseType<FaqCategoryListResponse>>(
      `/admin/faq/categories/${id}/rank`,
      payload,
    )
  },
  deleteFaqCategory(id: string) {
    return instance.delete<ResponseType<FaqCategoryDeleteResponse>>(`/admin/faq/categories/${id}`)
  },
  getFaqArticleDetail(id: string) {
    return instance.get<ResponseType<FaqArticleDetail>>(`/admin/faq/articles/${id}`)
  },
  createFaqArticle(payload: FaqArticlePayload) {
    return instance.post<ResponseType<FaqArticleDetail>>('/admin/faq/articles', payload)
  },
  updateFaqArticle(id: string, payload: FaqArticlePayload) {
    return instance.patch<ResponseType<FaqArticleUpdateResponse>>(
      `/admin/faq/articles/${id}`,
      payload
    )
  },
  updateFaqArticleStatus(id: string, payload: FaqArticleStatusPayload) {
    return instance.patch<ResponseType<FaqArticleDetail>>(
      `/admin/faq/articles/${id}/status`,
      payload
    )
  },
  reorderFaqArticle(id: string, payload: FaqArticleReorderPayload) {
    return instance.patch<ResponseType<FaqArticleReorderResponse>>(
      `/admin/faq/articles/${id}/rank`,
      payload,
    )
  },
  deleteFaqArticle(id: string) {
    return instance.delete<ResponseType<FaqArticleDeleteResponse>>(`/admin/faq/articles/${id}`)
  },
}
